import { render, staticRenderFns } from "./UpdateStatusDialog.vue?vue&type=template&id=3ffe0968&"
import script from "./UpdateStatusDialog.vue?vue&type=script&lang=js&"
export * from "./UpdateStatusDialog.vue?vue&type=script&lang=js&"
import style0 from "./UpdateStatusDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports